import { PkSpinner } from '@uefadigital/panenka-react';
import { lazy, Suspense } from 'react';
import { createHashRouter, Navigate } from 'react-router';

import ImpressionHandler from 'Services/ImpressionHandler';

const About = lazy(() => import('Pages/About/About'));
const ArticleView = lazy(() => import('Pages/ArticleView/ArticleView'));
const FootballNearYou = lazy(() => import('Pages/FootballNearYou/FootballNearYou'));
const HashtagView = lazy(() => import('Pages/HashtagView/HashtagView'));
const NotFound = lazy(() => import('Pages/NotFound/NotFound'));
const Partners = lazy(() => import('Pages/Partners/Partners'));
const Supporters = lazy(() => import('Pages/Supporters/Supporters'));
const Trending = lazy(() => import('Pages/Trending/Trending'));
const Main = lazy(() => import('Pages/Main/Main'));
//const OffMute = lazy(() => import('Pages/OffMute/OffMute'));

export const PublicRoutes = {
  trending: '/trending',
  footballNearYou: '/football-near-you',
  supporters: '/supporters',
  partners: '/partners',
  about: '/about',
  articleView: '/article-view',
  hashtagView: '/hashtag-view',
  offMute: '/off-mute',
};

export const router = createHashRouter(
  [
    {
      path: '/',
      element: (
        <Suspense fallback={<PkSpinner />}>
          <Main />
        </Suspense>
      ),
      errorElement: (
        <Suspense fallback={<PkSpinner />}>
          <NotFound />
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: <Navigate to={PublicRoutes.trending} replace />,
        },
        {
          path: PublicRoutes.trending,
          element: <Trending />,
        },
        {
          path: PublicRoutes.about,
          element: <About />,
        },
        {
          path: PublicRoutes.footballNearYou,
          element: <FootballNearYou />,
        },
        {
          path: PublicRoutes.partners,
          element: <Partners />,
        },
        {
          path: PublicRoutes.supporters,
          element: <Supporters />,
        },
        {
          path: PublicRoutes.articleView,
          element: <ArticleView />,
          children: [
            {
              path: ':articleId',
              element: <ArticleView />,
            },
          ],
        },
        {
          path: PublicRoutes.hashtagView,
          element: <HashtagView />,
          children: [
            {
              path: ':hashtag',
              element: <HashtagView />,
            },
          ],
        },
      ],
    },
    /*
    OFF_MUTE
    {
      path: PublicRoutes.offMute,
      element: <Navigate to={`/${i18n.language}/off-mute`} replace />,
    },
    {
      path: '/:lang/off-mute',
      element: (
        <Suspense fallback={<PkSpinner />}>
          <OffMute />
        </Suspense>
      ),
    },*/
    {
      path: '/index.html',
      element: <Navigate to='/' />,
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ].filter(Boolean),
);
router.subscribe(() => {
  ImpressionHandler.sendAll();
});
